import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";

const MedicationWaiverConsent = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => (
  <Button onClick={() => setQuestionAnswer(true)}>Continue</Button>
);

export { MedicationWaiverConsent };
